import axios from 'axios'
import store from './store'
import router from './router'

//var instance = axios.create({ baseURL: 'http://localhost:3017/api', timeout: 600000 })

//var instance = axios.create({ baseURL: 'https://amulet.szivarvanyaqua.hu/api', timeout: 600000 })

var instance = axios.create({ baseURL: 'https://iroda.szivarvanyaqua.hu/api', timeout: 600000 })

instance.interceptors.request.use(config=>{
    config.headers.user = store.getters.user !== null ? store.getters.user.loginnev : ``,
  	config.headers.token = store.getters.token !== null ? store.getters.token : ``
    return config
  }, error=>{
    return Promise.reject(error)
  })

instance.interceptors.response.use(
    response => {
        if(response.data === 'denied') {
            store.dispatch('setuser', null)
            store.dispatch('settoken', null)
            router.push('/user_error')
        }
        return response
    },
    error => {
        if (
            error.request.responseType === 'blob' &&
            error.response.data instanceof Blob &&
            error.response.data.type &&
            error.response.data.type.toLowerCase().indexOf('json') != -1
        ) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader()
                reader.onload = () => {
                    error.response.data = JSON.parse(reader.result)
                    resolve(Promise.reject(error))
                }

                reader.onerror = () => { reject(error) }

                reader.readAsText(error.response.data)
            })
        }

        return Promise.reject(error)
    }
)

export default instance


// WEBPACK FOOTER //
// ./src/axios.js